module.exports = __webpack_public_path__ + "img/first_down_right.e09339b9.jpg";